import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export const TableHeaderToolsContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(3),
  display: "flex",
  gap: theme.spacing(1),
  alignItems: "center",
}));
